import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/nuxt-app/layouts/default.vue").then(m => m.default || m))
}